import { ArrowUpShort } from '@styled-icons/bootstrap/ArrowUpShort';
import type { ReactNode } from 'react';
import styled from 'styled-components';

export const StyledIconButton = styled.button<{
  ariaLabel: string;
  children: ReactNode;
  isVisible?: boolean;
  onClick?: () => void;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: white;
  color: black;
  border-radius: 6px;
  transition: all 0.3s ease;
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 9999;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  transform: ${({ isVisible }) =>
    isVisible ? 'translateY(0)' : 'translateY(100px)'};
  pointer-events: ${({ isVisible }) => (isVisible ? 'auto' : 'none')};

  @media ${({ theme }) => theme.media.tablet} {
    border: 1px solid ${({ theme }) => theme.palette.lightGray};
    display: block;
    width: 50px;
    height: 50px;
  }
`;

export const Icon = styled(ArrowUpShort)`
  width: 24px;
  height: 24px;

  svg {
    width: 24px;
    height: 24px;
  }
`;
